class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.content =
            this.mainDetailsToggle.querySelector("summary").nextElementSibling;

        this.mainDetailsToggle.addEventListener(
            "focusout",
            this.onFocusOut.bind(this),
        );
        this.mainDetailsToggle.addEventListener(
            "toggle",
            this.onToggle.bind(this),
        );
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();
        document
            .querySelectorAll("header details.mega-menu")
            .forEach((item) => {
                item.removeAttribute("open");
            });

        if (this.mainDetailsToggle.hasAttribute("open")) {
            this.animations.forEach((animation) => animation.play());
        } else {
            this.animations.forEach((animation) => animation.cancel());
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute("open");
        this.mainDetailsToggle
            .querySelector("summary")
            .setAttribute("aria-expanded", false);
    }
}

if (!customElements.get("details-disclosure")) {
    customElements.define("details-disclosure", DetailsDisclosure);
}

class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super();

        this.header = document.querySelector(".header-wrapper");
        this.megaMenuItem = this.querySelector(".mega-menu");
        this.header = this.closest("header");
        this.megaMenuItem.addEventListener(
            "mouseover",
            this.mouseOver.bind(this.megaMenuItem),
        );
        this.megaMenuItem.addEventListener(
            "mouseout",
            this.mouseOut.bind(this.megaMenuItem),
        );
    }

    mouseOver() {
        if (!this.hasAttribute("open")) {
            document
                .querySelectorAll("header details.mega-menu")
                .forEach((item) => {
                    item.removeAttribute("open");
                });
            this.setAttribute("open", "");
        }
    }

    mouseOut(e) {
        const isEdge = e.toElement.classList.contains(
            "header-wrapper--border-bottom",
        );
        if (!isEdge) this.removeAttribute("open");
    }

    onToggle() {
        if (!this.header) return;
        this.header.preventHide = this.mainDetailsToggle.open;

        if (
            document.documentElement.style.getPropertyValue(
                "--header-bottom-position-desktop",
            ) !== ""
        )
            return;
        document.documentElement.style.setProperty(
            "--header-bottom-position-desktop",
            `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
        );
    }
}

if (!customElements.get("header-menu")) {
    customElements.define("header-menu", HeaderMenu);
}

export { DetailsDisclosure };
